import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const numberStepperStyles: IStyles = {
    root: {
        flex: '1 1 0',
        minWidth: 0,
        width: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
    },
    label: {
        fontSize: 11,
        fontWeight: 500,
        color: color.fontDarkLow,
        lineHeight: 1.2,
    },
    control: {
        display: 'flex',
        alignItems: 'stretch',
        height: 30,
        border: `1px solid ${color.borderDarkPrimary}`,
        borderRadius: 6,
        background: color.bgWhitePrimary,
        overflow: 'hidden',
        transition: 'border-color 0.15s',

        '&:hover': {
            borderColor: color.borderDarkSecondary,

            '& $steppers': {
                opacity: 0.85,
            },
        },
    },
    controlFocused: {
        borderColor: color.borderDarkSecondary,
        background: color.bgWhitePrimary,
        boxShadow: 'none',

        '& $steppers': {
            opacity: 0.85,
        },
    },
    controlDisabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
    input: {
        flex: 1,
        minWidth: 0,
        border: 'none',
        outline: 'none',
        background: 'transparent',
        padding: '0 8px',
        fontFamily: 'inherit',
        fontSize: 12,
        color: color.fontDarkHigh,
        width: '100%',

        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        MozAppearance: 'textfield',
    },
    steppers: {
        display: 'flex',
        flexDirection: 'column',
        width: 18,
        flexShrink: 0,
        borderLeft: `1px solid ${color.borderDarkPrimary}`,
        opacity: 0.4,
        transition: 'opacity 0.15s',
    },
    stepBtn: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        margin: 0,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        color: color.fontDarkUltraLow,
        lineHeight: 1,

        '&:hover': {
            color: color.fontDarkMedium,
            background: 'transparent',
        },

        '&:active': {
            color: color.fontDarkHigh,
        },

        '&:first-child': {
            borderBottom: `1px solid ${color.borderDarkPrimary}`,
        },
    },
}

addStyles(numberStepperStyles)
export default numberStepperStyles
